import Head from 'next/head';
import dynamic from 'next/dynamic';

const SudokuGame = dynamic(() => import('../../components/games/SudokuGame'), { ssr: false });

export default function SudokuPage() {
  const url = 'https://fenkparet.com/jeux/sudoku';
  return (
    <>
      <Head>
        <title>Sudoku: Jeu logique quotidien en français | Fenkparet</title>
        <meta name="description" content="Sudoku en français — 5 niveaux de difficulté, défi du jour, parties libres. Entraînez votre logique chaque jour !" />
        <meta name="keywords" content="sudoku, sudoku français, jeu logique, puzzle, défi quotidien, grille 9x9, sudoku en ligne" />
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        <link rel="canonical" href={url} />

        {/* OpenGraph */}
        <meta property="og:title" content="Sudoku — Jeu logique quotidien | Fenkparet" />
        <meta property="og:description" content="5 niveaux de difficulté, défi du jour, parties libres. Entraînez votre logique chaque jour !" />
        <meta property="og:type" content="game" />
        <meta property="og:url" content={url} />
        <meta property="og:locale" content="fr_FR" />
        <meta property="og:site_name" content="Fenkparet" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sudoku — Jeu logique quotidien" />
        <meta name="twitter:description" content="5 niveaux de difficulté, défi du jour, parties libres." />

        {/* JSON-LD */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Game',
          name: 'Sudoku',
          description: 'Remplissez la grille 9×9 sans répétition — 5 niveaux de difficulté, défi quotidien.',
          url,
          gamePlatform: 'Web Browser',
          genre: 'Puzzle',
          numberOfPlayers: '1',
          inLanguage: 'fr',
          isAccessibleForFree: true,
          publisher: { '@type': 'Organization', name: 'Fenkparet', url: 'https://fenkparet.com' },
        }) }} />

        {/* BreadcrumbList */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://fenkparet.com' },
            { '@type': 'ListItem', position: 2, name: 'Jeux', item: 'https://fenkparet.com/jeux' },
            { '@type': 'ListItem', position: 3, name: 'Sudoku', item: url },
          ],
        }) }} />
      </Head>
      <SudokuGame />
    </>
  );
}
